<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Preparing Report - {{reportTitle}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="this.activeModal.close({status: 'Cancelled'})"></button>
</div>
<div class="modal-body">
  @if (statusText !== '') {
    <div>{{statusText}}</div>
  }
  @if (errorText !== '') {
    <div>{{errorText}}</div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="this.activeModal.close({status: 'Cancelled'})">Cancel</button>
  @if (enableRetry) {
    <div>
      <button type="button" class="btn btn-outline-dark" (click)="this.requestReport()">Retry</button>
    </div>
  }
</div>
